import { getDefaultStore } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { match } from 'ts-pattern'
import { TurnstileWidgetMode } from '~/services/apollo/generated/graphql'
import { config } from '~/utils/config'

export const turnstileSiteKeyTypeAtom = atomWithStorage(
  'debug::turnstile-site-key-type',
  '',
  undefined,
  { getOnInit: true },
)
export const getTurnstileSiteKey = (
  widgetMode: TurnstileWidgetMode,
): string => {
  const type = getDefaultStore().get(turnstileSiteKeyTypeAtom)
  // see https://developers.cloudflare.com/turnstile/troubleshooting/testing/
  if (type === 'test-always-pass') {
    return match(widgetMode)
      .returnType<string>()
      .with(TurnstileWidgetMode.Managed, () => '1x00000000000000000000AA')
      .with(
        TurnstileWidgetMode.NonInteractive,
        () => '1x00000000000000000000AA',
      )
      .with(TurnstileWidgetMode.Invisible, () => '1x00000000000000000000BB')
      .exhaustive()
  }
  if (type === 'test-always-block') {
    return match(widgetMode)
      .returnType<string>()
      .with(TurnstileWidgetMode.Managed, () => '2x00000000000000000000AB')
      .with(
        TurnstileWidgetMode.NonInteractive,
        () => '2x00000000000000000000AB',
      )
      .with(TurnstileWidgetMode.Invisible, () => '2x00000000000000000000BB')
      .exhaustive()
  }
  if (type === 'test-force-interactive') {
    return match(widgetMode)
      .returnType<string>()
      .with(TurnstileWidgetMode.Managed, () => '3x00000000000000000000FF')
      .with(
        TurnstileWidgetMode.NonInteractive,
        () => '1x00000000000000000000AA',
      )
      .with(TurnstileWidgetMode.Invisible, () => '1x00000000000000000000BB')
      .exhaustive()
  }
  return match(widgetMode)
    .returnType<string>()
    .with(TurnstileWidgetMode.Managed, () => config.turnstile.managedSiteKey)
    .with(
      TurnstileWidgetMode.NonInteractive,
      () => config.turnstile.nonInteractiveSiteKey,
    )
    .with(
      TurnstileWidgetMode.Invisible,
      () => config.turnstile.invisibleSiteKey,
    )
    .exhaustive()
}
